import { gql } from '@apollo/client';

export const CUSTOM_ENTITY_TYPES = gql`
  fragment CustomEntityTypeConfigListItemFragment on CustomEntityType {
    id
    identifier
    name
    fields
  }

  query CustomEntityTypes($offset: Int, $limit: Int) {
    customEntityTypes(offset: $offset, limit: $limit) {
      hasNextPage
      objects {
        ...CustomEntityTypeConfigListItemFragment
      }
      total
    }
  }
`;

export const DELETE_CUSTOM_ENTITY_TYPE = gql`
  mutation DeleteCustomEntityType($id: ID!) {
    deleteCustomEntityType(id: $id) {
      ok
    }
  }
`;

export const CREATE_CUSTOM_ENTITY_TYPE = gql`
  mutation CreateCustomEntityType($fields: CreateCustomEntityTypeFields!) {
    createCustomEntityType(fields: $fields) {
      data {
        id
        identifier
        name
        fields
      }
    }
  }
`;

export const UPDATE_CUSTOM_ENTITY_TYPE = gql`
  mutation UpdateCustomEntityType(
    $fields: UpdateCustomEntityTypeFields!
    $id: ID!
  ) {
    updateCustomEntityType(fields: $fields, id: $id) {
      data {
        id
        identifier
        name
        fields
      }
    }
  }
`;

export const RESERVED_ENTITY_FIELDS_QUERY = gql`
  query ReservedEntityFieldsOperation {
    entityFields
  }
`;
